import { useState, useEffect } from 'react';
import { Project, CreateProjectRequest } from '../types/project';
import { projectsApi } from '../services/api';

export const useProjects = () => {
  const [projects, setProjects] = useState<Project[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchProjects = async () => {
    try {
      setLoading(true);
      setError(null);
      const fetchedProjects = await projectsApi.getProjects();
      setProjects(fetchedProjects);
    } catch (err) {
      console.error('Error fetching projects:', err);
      setError('Failed to fetch projects');
    } finally {
      setLoading(false);
    }
  };

  const createProject = async (request: CreateProjectRequest): Promise<Project | null> => {
    try {
      setError(null);
      const newProject = await projectsApi.createProject(request);
      setProjects(prev => [newProject, ...prev]);
      return newProject;
    } catch (err) {
      console.error('Error creating project:', err);
      setError('Failed to create project');
      return null;
    }
  };

  const getProject = async (projectId: string): Promise<Project | null> => {
    try {
      setError(null);
      const project = await projectsApi.getProject(projectId);
      return project;
    } catch (err) {
      console.error('Error fetching project:', err);
      setError('Failed to fetch project');
      return null;
    }
  };

  useEffect(() => {
    fetchProjects();
  }, []);

  return {
    projects,
    loading,
    error,
    fetchProjects,
    createProject,
    getProject,
  };
};

export default useProjects;